import React, { useState } from "react";
import { Modal } from "@linkfluence/core/modal";
import { notifyError, notifySuccess } from "@linkfluence/core/notifications";
import { Locale } from "@linkfluence/models/locale";
import PasteModalComponent from "@radarly/components/modals/paste";
import ConfirmationPasteComponent from "@radarly/components/modals/paste/confirmation";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { Clause } from "@radarly/models/clause";
import { PasteID, PastePayload } from "@radarly/models/insight-pages/editor";

export default function usePasteModal(
  onPasteFilters: (position: number, row: number, clause: Clause) => void,
  onPasteCard: (position: number, row: number, card: Card) => void,
  setActiveCard: ({ position, idRow }) => void,
  locale: Locale,
  modaleID: string
) {
  const [id, setId] = useState<PasteID>(null);
  const [payload, setPayload] = useState<PastePayload>(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { open, close, ModalWrapper } = Modal.get(modaleID);
  const [{ position, row }, setSelectedCard] = useState({
    position: null as number,
    row: null as number,
  });

  const onOpenPasteModal = (position: number, row: number, id: PasteID) => {
    setActiveCard({ position: null, idRow: null });
    setSelectedCard({ position, row });
    setId(id);
    open();
  };

  const onConfirm = async () => {
    try {
      if (id === "paste_card") {
        onPasteCard(position, row, payload as Card);
        notifySuccess(
          tr(locale, "INSIGHT_PAGES_EDITOR_CARD_PASTED_OK"),
          tr(locale, "INSIGHT_PAGES_EDITOR_CARD_PASTED_OK_TEXT")
        );
      }
      if (id === "paste_filters") {
        onPasteFilters(position, row, payload as Clause);
        notifySuccess(
          tr(locale, "INSIGHT_PAGES_EDITOR_FILTERS_PASTED_OK"),
          tr(locale, "INSIGHT_PAGES_EDITOR_FILTERS_PASTED_OK_TEXT")
        );
      }
      setShowConfirmation(false);
      return close();
    } catch (_) {
      if (id === "paste_card") {
        return notifyError(
          tr(locale, "INSIGHT_PAGES_EDITOR_CARD_PASTED_ERROR"),
          tr(locale, "INSIGHT_PAGES_EDITOR_CARD_PASTED_ERROR_TEXT")
        );
      }
      return notifyError(
        tr(locale, "INSIGHT_PAGES_EDITOR_FILTERS_PASTED_ERROR"),
        tr(locale, "INSIGHT_PAGES_EDITOR_FILTERS_PASTED_ERROR_TEXT")
      );
    }
  };

  const onSelection = (payload: PastePayload) => {
    setShowConfirmation(true);
    setPayload(payload);
  };

  const onClose = () => {
    setShowConfirmation(false);
    close();
  };

  const PasteModal = () => (
    <ModalWrapper>
      {id &&
        (showConfirmation ? (
          <ConfirmationPasteComponent
            onClose={onClose}
            onApply={onConfirm}
            locale={locale}
            type={id}
          />
        ) : (
          <PasteModalComponent
            onClose={onClose}
            onApply={onSelection}
            locale={locale}
            type={id}
          />
        ))}
    </ModalWrapper>
  );
  return {
    PasteModal,
    onOpenPasteModal,
  };
}
